import { render, staticRenderFns } from "./WaSideMenuItems.vue?vue&type=template&id=8bad2738"
import script from "./WaSideMenuItems.vue?vue&type=script&lang=js"
export * from "./WaSideMenuItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports